import { Component, OnInit, ViewContainerRef, Input, Renderer2 } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NdmsFormControlComponent } from '../../../../../../shared/ui-ndms/forms/ndms-form-control/ndms-form-control.component';
import { LookupValueViewModel } from '../../../../../../shared/ui-ndms/view-models/lookup-value.view-model';
import { TeamsService } from '../../../core-rms/teams.service';


@Component({
  selector: 'teams-select',
  templateUrl: './teams-select.component.html',
  styleUrls: ['./teams-select.component.scss']
})
export class TeamsSelectComponent extends NdmsFormControlComponent implements OnInit {
  constructor(private teamsService: TeamsService, viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  private teamData: any;
  private isPopulating: boolean = false;
  private isPopulated: boolean = false;

  ngOnInit() {
    this.populateData();
  }

  canAddArrayItem(currentIndex: number) {
    return true;
  }

  compareFn(c1: LookupValueViewModel, c2: LookupValueViewModel): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  getText() {
    if (!this.value || !this.value.id) {
      return 'N/A';
    }

    return this.value.display;
  }

  populateData() {
    if (!this.isPopulated) {
      this.isPopulating = true;

      this.teamsService.searchTeams({ showAll: true }).subscribe((results) => {
        console.log("results" + results);
        this.teamData = results.map((model) => {
          console.log(model)
          return {
            id: model.teamId,
            display: model.teamName
          }
        });

        this.isPopulating = false;
        this.isPopulated = true;
      });

      return false;
    }
  }

  getTeamData() {
    return this.teamData;
  }

  getDefaultOptionText() {
    if (this.isPopulating) {
      return 'Loading...';
    }

    return 'Select an Option';
  }
}
